import { FC, ReactNode } from 'react';

interface LoadingPlaceholderProps {
    isLoading: boolean;
    skeleton: ReactNode;
    children: ReactNode;
}

const LoadingPlaceholder: FC<LoadingPlaceholderProps> = ({ isLoading, skeleton, children }) => {
    return <>{isLoading ? skeleton : children}</>;
};

export default LoadingPlaceholder;
